// Works around issue described here https://stackoverflow.com/a/51271892

import $ from 'jquery';

window.$ = $;
window.jQuery = $;

export default $;
